import { useRef, useEffect } from 'react';
import paper from 'paper';

// Phantom cursor traces a Lissajous figure leaving a growing dashed trail.
// Trail resets every few seconds so the canvas never fully fills.
const SnakePreview = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    paper.setup(canvasRef.current);
    const w = paper.view.size.width;
    const h = paper.view.size.height;
    const cx = w / 2, cy = h / 2;

    const trail = new paper.Path();
    trail.strokeColor = 'blue';
    trail.strokeWidth = 10;
    trail.strokeCap = 'round';

    let dashCounter = 5;
    let frameCount = 0;

    const onFrame = () => {
      frameCount++;
      const t = Date.now() * 0.002;
      // Lissajous 2:3 figure
      const mx = cx + Math.sin(t * 2) * cx * 0.65;
      const my = cy + Math.sin(t * 3 + Math.PI / 4) * cy * 0.65;

      // Reset trail periodically
      if (frameCount % 220 === 0) {
        trail.segments = [];
        dashCounter = 5;
      }

      trail.add(new paper.Point(mx, my));
      dashCounter += 0.06;
      trail.dashArray = [dashCounter, 10];
    };

    paper.view.on('frame', onFrame);
    return () => { paper.view.off('frame', onFrame); paper.project.clear(); };
  }, []);

  return <canvas ref={canvasRef} style={{ width: '100%', height: '100%', backgroundColor: 'white' }} />;
};

export default SnakePreview;
